import { z } from 'zod';

export const SentrySchema = z.object({
  SENTRY_DSN: z.string(),
  SENTRY_RELEASE: z.string(),
  STAGE: z.string(),
});

export const parseSentryVars = (
  vars: z.infer<typeof SentrySchema> | unknown,
) => {
  // we only want to send errors to sentry in production
  if (!import.meta.env.PROD) return { environment: 'dev' };

  try {
    const { SENTRY_DSN, SENTRY_RELEASE, STAGE } = SentrySchema.parse(vars);

    return { dsn: SENTRY_DSN, release: SENTRY_RELEASE, environment: STAGE };
  } catch (thrown: z.ZodErrorMap | unknown) {
    if (thrown instanceof z.ZodError) {
      // eslint-disable-next-line no-console
      console.error('Error parsing Sentry environment variables\n', {
        issues: thrown.issues,
        vars,
      });
    }
    throw thrown;
  }
};
